
import React from 'react';
import { PasswordStrength } from '@/hooks/usePasswordValidation';

interface PasswordStrengthMeterProps {
  password: string;
  strength: PasswordStrength;
}

export function PasswordStrengthMeter({ password, strength }: PasswordStrengthMeterProps) {
  if (!password) return null;

  const getPasswordStrengthColor = () => {
    switch (strength) {
      case 'weak': return 'bg-red-500';
      case 'medium': return 'bg-yellow-500';
      case 'strong': return 'bg-green-500';
      default: return 'bg-gray-300';
    }
  };

  const getWidthPercentage = () => {
    switch (strength) {
      case 'weak': return '33%';
      case 'medium': return '66%';
      case 'strong': return '100%';
      default: return '0%';
    }
  };

  const getStrengthLabel = () => {
    switch (strength) {
      case 'weak': return 'Weak';
      case 'medium': return 'Medium';
      case 'strong': return 'Strong';
      default: return '';
    }
  };

  return (
    <div className="mt-2">
      <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
        <div 
          className={`h-full ${getPasswordStrengthColor()} transition-all duration-300`} 
          style={{ width: getWidthPercentage() }}
        />
      </div>
      <p className="text-xs mt-1 text-muted-foreground">
        Password strength: {getStrengthLabel()}
      </p>
    </div>
  );
}
